import { render, staticRenderFns } from "./TeacherDataCenterLayout.vue?vue&type=template&id=89493236&scoped=true&"
import script from "./TeacherDataCenterLayout.vue?vue&type=script&lang=js&"
export * from "./TeacherDataCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDataCenterLayout.vue?vue&type=style&index=0&id=89493236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89493236",
  null
  
)

export default component.exports